export const CSS = {
	row: 'c-LocationFieldInput',
	label: 'c-LocationFieldInput__label',
	inputs: 'c-LocationFieldInput__input',
	error: 'c-LocationFieldInput__error',
	MDL: {
		error: 'mdl-textfield__error',
	},
};

export const Style = {
	[CSS.row]: {
		display: 'block',
		'align-items': 'center',
	},
	[CSS.label]: {
		display: 'inline-block',
		width: '25%',
	},
	[CSS.inputs]: {
		display: 'inline-block',
		width: '75%',
	},
	[CSS.error]: {
		visibility: 'visible',
		position: 'relative',
	},
};
